import { Resource as ResourceType, Sys } from '@/generated/contentfulTypes';
import { Maybe } from 'graphql/jsutils/Maybe';

export enum BannerTextLocationVariants {
  Side = 'Side',
  Top = 'Top',
}
export type BannerTextLocation = keyof typeof BannerTextLocationVariants | null;

export interface BaseItemProps {
  __typename?: string;
  sys?: Sys;
  title?: Maybe<ResourceType> | string;
  description?: Maybe<{ json: { content: any } }> | string;
  bannerText?: Maybe<ResourceType>;
  bannerTextLocation?: Maybe<BannerTextLocation>;
  price?: Maybe<number>;
  period?: Maybe<ResourceType>;
  additionalSubtext?: Maybe<ResourceType>;
  highlightedBenefits?: Maybe<ResourceType>[] | Maybe<ResourceType>;
  includedBenefits?: Maybe<ResourceType>[];
  excludedBenefits?: Maybe<ResourceType>[];
  [key: string]: any;
}
